import { Component } from '@angular/core';

@Component({
  selector: 'app-fo-connected',
  standalone: false,
  templateUrl: './fo-connected.component.html',
  styleUrls: ['./fo-connected.component.css']
})
export class FoConnectedComponent {}
